import { FieldOptionDataType } from '../../utils/constants';
import { PathFieldOption, FieldOption } from '../../utils/types';

import {
  COMPOUND_DATA_TYPE_FIELD_OPTIONS,
  CUSTOM_DOMAIN_PICKLIST_FIELDS,
  CUSTOM_DOMAIN_PICKLIST_FIELD_SALESFORCE_TYPES,
  DomainPicklistAutoMapFields,
  PICKLIST_FIELD_SALESFORCE_FIELD_TYPES,
} from '../../utils/constants';

export const getIsFieldOptionDisabled = ({
  option,
  fieldDomainPath,
  isPicklistFieldType,
}: {
  option: PathFieldOption;
  fieldDomainPath: string;
  isPicklistFieldType: boolean;
}) => {
  const enabledOptionTypes = CUSTOM_DOMAIN_PICKLIST_FIELDS.includes(
    fieldDomainPath as DomainPicklistAutoMapFields,
  )
    ? CUSTOM_DOMAIN_PICKLIST_FIELD_SALESFORCE_TYPES
    : PICKLIST_FIELD_SALESFORCE_FIELD_TYPES;

  const isCompoundFieldType = COMPOUND_DATA_TYPE_FIELD_OPTIONS.includes(
    option?.dataType as FieldOptionDataType,
  );

  const isDisabledPicklistType =
    isPicklistFieldType && !enabledOptionTypes.includes(option?.dataType);

  return isCompoundFieldType || isDisabledPicklistType;
};

export const getNoOptionsText = ({
  isLoading,
  searchInput,
}: {
  isLoading: boolean;
  searchInput: string;
}) => {
  if (isLoading) {
    return searchInput ? 'Searching...' : 'Start typing to search...';
  }

  return 'No fields found';
};

export const getSalesforcePathFromOption = ({
  option,
}: {
  option: FieldOption;
}) => {
  return `${option?.parentId}.${option?.fieldId}`;
};

export const getSalesforcePathLabelFromOption = ({
  option,
}: {
  option: FieldOption;
}) => {
  return `${option?.parentId} > ${option?.fieldLabel}`;
};
